<template>
  <div class="part-base-dialog">
    <custom-dialog class="afterSaleRole-item-dialog" width="900px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" size="small" ref="form" label-position="top">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="8">
                <el-col :span="8">
                  <el-form-item :label="$t('asm_feedBack_item_dialog.ling_jian_bian_hao')" prop="partCode" :rules="rules.partCode">
                    <custom-select
                      url="partList"
                      v-model="form.partId"
                      :filterable="true"
                      :placeholder="$t('Common.com_please_select')"
                      :props="{ label: 'codeName', value: 'partId' }"
                      width="100%"
                      @change="onPartCodeChange"
                    ></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('asm_feedBack_item_dialog.ling_jian_lei_bie')">
                    <custom-select v-model="form.partClass" code="asm_part_class" width="100%" :placeholder="$t('Common.com_please_select')" :disabled="true"></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('asm_feedBack_item_dialog.ling_jian_lei_xing')">
                    <custom-select v-model="form.partType" code="asm_part_type" width="100%" value-type="number" :placeholder="$t('Common.com_please_select')" :disabled="true"></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('asm_feedBack_item_dialog.ling_jian_ming_cheng')">
                    <el-input :disabled="true" v-model="form.partName" style="100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('asm_feedBack_item_dialog.ling_jian_gui_ge')">
                    <el-input :disabled="true" v-model="form.partSpec" style="100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('asm_feedBack_item_dialog.ling_jian_dan_wei')">
                    <custom-select v-model="form.partUnit" code="after_sale_unit" :placeholder="$t('Common.com_please_select')" width="100%" :disabled="true"></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('asm_feedBack_item_dialog.ling_jian_shu_liang')" prop="replaceNum" :rules="rules.replaceNum">
                    <el-input-number v-model="form.replaceNum" :min="1"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('asm_feedBack_item_dialog.shi_fou_jin_shui')" prop="isSoak" :rules="rules.isSoak">
                    <custom-select v-model="form.isSoak" code="isynergy_cloud_bool" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('asm_feedBack_item_dialog.ling_jianSN')">
                    <el-input v-model="form.partSn" style="100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('asm_feedBack_item_dialog.gu_zhang_miao_shu')" prop="feedBackDesc" :rules="rules.feedBackDesc">
                <el-input type="textarea" :rows="3" v-model="form.feedBackDesc" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('asm_feedBack_item_dialog.ling_jian_tu_pian')" prop="picList">
                <t-upload ref="feedBackItem" :limit="3" :bizId="form.feedBackId" bizType="asm.feedBack.icon" v-model="form.picList" :autoUpload="false"></t-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button size="small" type="primary" @click="confirm(0)">{{ $t('Common.com_save') }}</el-button>
        <el-button size="small" type="primary" @click="confirm(1)">{{ $t('Common.com_submit') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: { tUpload },

  data() {
    return {
      ossConfig: {},
      item: {},
      // visible: false,
      fileList: [],
      form: {
        feedBackId: '',
        partId: '',
        partCode: '',
        partName: '',
        partClass: '',
        partType: '',
        partSpec: '',
        partUnit: '',
        replaceNum: '',
        isSoak: '0',
        partSn: '',
        feedBackDesc: '',
        picList: [],
        isSubmit: 1,
        changeId: '',
        workOrderId: ''
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        partCode: [
          {
            required: true,
            message: this.$t('asm_feedBack_item_dialog.qtxljbh'),
            //
          },
        ],
        partName: [
          {
            required: true,
            message: this.$t('asm_feedBack_item_dialog.qsrljmc'),
            //
          },
        ],
        partClass: [
          {
            required: true,
            message: this.$t('asm_feedBack_item_dialog.qxzljlb'),
            //
          },
        ],
        partType: [
          {
            required: true,
            message: this.$t('asm_feedBack_item_dialog.qxzljlx'),
            //
          },
        ],
        partSpec: [
          {
            required: true,
            message: this.$t('asm_feedBack_item_dialog.qtxljgg'),
            //
          },
        ],
        partUnit: [
          {
            required: true,
            message: this.$t('asm_feedBack_item_dialog.qing_xuan_ze_dan_wei'),
            //
          },
        ],
        replaceNum: [
          {
            required: true,
            message: this.$t('asm_feedBack_item_dialog.qtxljsl'),
            //
          },
        ],
        partSn: [
          {
            required: true,
            message: this.$t('asm_feedBack_item_dialog.qtxljSN'),
            //
          },
        ],
        isSoak: [
          {
            required: true,
            message: this.$t('asm_feedBack_item_dialog.qxzsfjs'),
            //
          },
        ],
        feedBackDesc: [
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
          {
            required: true,
            message: this.$t('asm_feedBack_item_dialog.qtxgzms'),
            //
          },
        ],
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        // this.visible = true;
      });
      if (this.model.type === 'edit') {
        this.getDetail();
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    getDetail: function () {
      this.$getJSON(apis.feedbackInfo, { feedBackId: this.model.data.feedBackId }).then((res) => {
        const data = res.data;
        this.$setFormatData(this.form, data);
      });
    },
    onPartCodeChange: function (item) {
      if (item) {
        this.form.partCode = item.partCode;
        this.form.partName = item.partName;
        this.form.partClass = item.partClass;
        this.form.partType = item.partType;
        this.form.partSpec = item.partSpec;
        this.form.partUnit = item.partUnit;
      }
    },
    // 确认保存
    confirm: async function (isSubmit) {
      this.form.isSubmit = isSubmit;
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return;
        }
        await this.$refs.feedBackItem.submit();
        if (this.model.type === 'add') {
          this.saveInsert(isSubmit);
        }
        if (this.model.type === 'workOrderAdd') {
          this.form.workOrderId = this.model.data.workOrderId;
          this.saveInsert(isSubmit);
        }
        if (this.model.type === 'edit') {
          this.saveUpdate(isSubmit);
        }
      });
    },
    // 保存新增
    saveInsert: function (isSubmit) {
      this.$postJSON(apis.feedbackApply, this.form).then((res) => {
        // 提交审批
        if (isSubmit) {
          this.form.changeId = res.data;
          this.$postJSON(`${apis.apsApproveApprovalApproveStart}/feed_back/${this.form.changeId}`, this.form, true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.$emit('success');
            this.closeDialog();
          });
        } else {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
          this.$emit('success');
          this.closeDialog();
        }

      });
    },
    // 保存编辑
    saveUpdate: function (isSubmit) {
      this.$postJSON(apis.feedbackApply, this.form).then((res) => {
        // 提交审批
        if (isSubmit) {
          this.form.changeId = res.data;
          this.$postJSON(`${apis.apsApproveApprovalApproveStart}/feed_back/${this.form.changeId}`, this.form, true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.closeDialog();
            this.$emit('success', this.form);
          });
        } else {
          this.$message({
            message: this.$t('Common.com_edit_success'),
            type: 'success',
          });
          this.closeDialog();
          this.$emit('success', this.form);
        }

      });
    },
  },
};
</script>

<style lang="scss">
.part-base-dialog {
  .el-upload--text {
    height: 82px;
    width: 82px;
    position: relative;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .upload-bd .el-upload--text {
    width: 178px;
    height: 178px;
    .el-icon-plus {
      font-size: 28px;
    }
  }
  .title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    line-height: 24px;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .left {
    border-right: 1px solid #eef2f8;
    padding-right: 24px;
  }
  .right {
    padding-left: 24px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 14px;
  }
}
</style>
